import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { Button, Box, CircularProgress } from '@material-ui/core';

import { usePageBallotCopyStyles } from '../styles';
import AppInput from '../../../../common/AppInput';
import AuthorizeCheckbox from '../../../mis-compras/components/report-issue-view/forms/authorizeThird/AuthorizeCheckbox';
import { bodyIssueTicketGenerator } from '../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../redux/actions/TicketActions';

import { REQUEST_NOT_PRODUCT_TICKET } from '../../../../../constants/Routes';

const genericError = 'Comentario requerido';

const FormErrorInPage = (props) => {
  const { idComplement, mobile, motiveId, type, title } = props;
  const [comment, setComment] = useState('');
  const [helperText, setHelperText] = useState('0/250');
  const [errorMessage, setErrorMessage] = useState(genericError);
  const [error, setError] = useState(false);
  const [checked, setChecked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const { profile } = useSelector((state) => state.profileReducer);
  const { ticketNoProductStatus } = useSelector(
    (innerState) => innerState.ticketReducer,
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = usePageBallotCopyStyles({ mobile });

  const onChangeComment = (e) => {
    const { value } = e.target;
    setHelperText(`${value.length}/250`);
    setComment(value);
  };

  const onBlurComment = (e) => {
    const { value } = e.target;
    if (value.length < 10) {
      setErrorMessage('Comentario requerido');
      setError(true);
      setSuccess(false);
      setDisabled(true);
    } else {
      setError(false);
      setSuccess(true);
      setDisabled(false);
    }
  };

  const onClickSent = () => {
    const body = bodyIssueTicketGenerator({
      profile,
      type,
      motiveId,
      comment,
    });
    dispatch(createTicketNoProduct(body));
  };

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') {
      setComment('');
      setError(false);
      setSuccess(false);
      setDisabled(true);
      history.push(REQUEST_NOT_PRODUCT_TICKET);
    }
  }, [ticketNoProductStatus]);

  return (
    <Box
      className={classes.container}
      margin={mobile ? '0px -16px' : ''}
      width={mobile ? 'auto' : '100%'}
    >
      <div className={classes.msgContainer}>
        <AppInput
          name="comentario"
          required
          helperText={helperText}
          label={title}
          value={comment}
          onClick={() => {}}
          onBlur={onBlurComment}
          onChange={onChangeComment}
          error={error}
          errorMessage={errorMessage}
          multiline
          success={success}
        />
        <AuthorizeCheckbox
          disabled={disabled}
          idComplement={`Form${idComplement}`}
          onCheck={() => setChecked(!checked)}
        />
        <div className={classes.contButton}>
          <Button
            className={classes.sendButton}
            variant="contained"
            color="primary"
            data-cy={`buttonSendForm${idComplement}`}
            onClick={onClickSent}
            disabled={
              !checked || disabled || ticketNoProductStatus === 'loading'
            }
          >
            {ticketNoProductStatus === 'loading' ? (
              <CircularProgress size={24} />
            ) : (
              'Enviar'
            )}
          </Button>
        </div>
      </div>
    </Box>
  );
};

FormErrorInPage.propTypes = {
  idComplement: PropTypes.string,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
};

export default FormErrorInPage;
